// extracted by mini-css-extract-plugin
export var attachmentPreviewStyles = "fJcFc";
export var content = "ovvvr";
export var firstRow = "iTqd0";
export var firstRowBase = "hQj7T";
export var firstRowThreeColumnNext = "gCSJa";
export var firstRowThreeColumnUnreadNext = "ukpDB";
export var mailListItem = "lHRXq";
export var mailListItemContainer = "jGG6V";
export var mailListItemRPRightPadding = "V9pSM";
export var mailListItemRightPadding = "CgZeR";
export var mclSecondRowStyles = "Mtj0E";
export var shortAttachmentPreviewStyles = "Wamaz";
export var showDeleteOnHover = "hDNlA";
export var singleLineViewContainer = "ZTnQq";
export var subject = "gmffI";
export var subjectTypeRampCompact = "Vno5W";
export var subjectTypeRampFull = "apfbR";
export var subjectTypeRampMedium = "YhDV2";
export var subjectUnread = "yg0l0";
export var subjectUnreadTypeRamp = "EX2We";
export var subjectUnreadTypeRampCompact = "ggB4p";
export var subjectUnreadTypeRampFull = "VEaov";
export var unreadBarGrow = "kOMna";
export var unreadMailListItem = "DLvHz";
export var unreadMailListItemDarker = "IMyk_";